module.exports = __webpack_public_path__ + "img/eliminar-duo.66657bec.svg";